/**
 * This file should be loaded through theme (ie. manifest in sage)
 */
var YsAjaxLoader = (function ($) {
  var settings = {
    targetEvent: 'click',
    targetSelector: '[data-ys-ajax-loader]',
    dataKey: 'ys-ajax-loader',
    loadingClass: 'loading',
    animationDuration: 1000,
  };

  var init = function () {
    $(document).on(settings.targetEvent, settings.targetSelector, loadContent);
  };

  var loadContent = function (e) {
    e.preventDefault();

    var target = $(this),
      data = target.data(settings.dataKey);

    if (!target.hasClass(settings.loadingClass)) {
      target.addClass(settings.loadingClass);

      data = $.extend(
        {
          action: 'ys_ajax_loader',
          nonce: ys_ajax_loader.nonce,
        },
        data
      );

      /**
       * @see site/web/app/themes/skoda-wlc-theme/assets/scripts/init-js/init.js
       */
      if (window.dispatchEventType) {
        window.dispatchEventType(
          document,
          'YsAjaxLoader.beforeRequest',
          undefined,
          undefined,
          undefined,
          { target: target, data: data }
        );
      }

      if (
        typeof data.preventLoad !== 'undefined' &&
        data.preventLoad === true
      ) {
        target.removeClass(settings.loadingClass);
        return;
      }

      var container = $(data.container);
      if (container.length > 0) {
        if (!target.data('container-height')) {
          var originalHeight = container.height();
          target.data('container-height', originalHeight);
        }
        var dataHeight = target.data('container-height');
        container.height(container.height() + dataHeight);
      }

      $.ajax({
        method: 'POST',
        url: ys_ajax_loader.ajax_url,
        data: data,
        success: function (response, status, xhr) {
          if (response.status === 'success') {
            if (response.html) {
              var content = $(response.html);
              /**
               * @see site/web/app/themes/skoda-wlc-theme/assets/scripts/init-js/init.js
               */
              if (window.dispatchEventType) {
                var nodes = [];
                content.each(function () {
                  nodes.push(this);
                });
                window.dispatchEventType(
                  document,
                  'YsAjaxLoader.beforeShowContent',
                  undefined,
                  undefined,
                  undefined,
                  { jQuery: content, nodes: nodes }
                );
              }
              showContent(content, data.container);
            }

            // Update the target data from the response
            if (response.data) {
              $.extend(true, data, response.data);
            }

            if (
              data.hasOwnProperty('items_remaining') &&
              !parseInt(data.items_remaining)
            ) {
              $(target).fadeOut().detach();
            }
          } else {
            console.log(response);
          }
        },
        error: function (xhr, status, error) {
          console.log(error);
        },
        complete: function (xhr, status) {
          $(target).removeClass(settings.loadingClass).blur();
          $(data.container).css('height', '');
        },
      });
    }
  };

  var showContent = function (content, container) {
    $(content).hide().appendTo(container).fadeIn(settings.animationDuration);

    /**
     * @see site/web/app/themes/skoda-wlc-theme/assets/scripts/init-js/init.js
     */
    if (window.dispatchEventType) {
      var nodes = [];
      content.each(function () {
        nodes.push(this);
      });
      window.dispatchEventType(
        document,
        'YsAjaxLoader.afterShowContent',
        undefined,
        undefined,
        undefined,
        { jQuery: content, nodes: nodes }
      );
    }

    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $(content).offset().top,
        },
        500,
        'swing'
      );
  };

  return {
    init: init,
  };
})(jQuery);
